export class VisitScheduleModel {
  visitTitle: string;
  scheduleIndex: number;
}

export class UpdateVisitScheduleRequest extends VisitScheduleModel {
  templateId: string;
}

export class VisitScheduleViewModel {
  public templateId: string;
  public scheduleIndex: number;
  public title: string;
  public keyVisit: boolean;
  public amount?: number;
  public caregiverAmount?: number;
  public editable: boolean = true;
  public inUse: boolean = false;
  public studyPhase: string;
  public type: string;
  public virtualCallType: string;

  get typeLabel(): string {
    if (!this.type) return '';
    if (this.type === 'Virtual' && this.virtualCallType) {
      const callLabel = this.virtualCallType === 'Audio' ? 'Audio Call' : 'Video Call';
      return `Virtual (${callLabel})`;
    }
    if (this.type === 'OnSite') return 'On-Site';
    if (this.type === 'Home') return 'Home';
    return this.type;
  }

  constructor(init?: Partial<VisitScheduleViewModel>) {
    Object.assign(this, init);
  }
}
